import React, { useRef, useState } from 'react';
import './Join.css';
import emailjs from '@emailjs/browser';

const Join = () => {
    const form = useRef();
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const validateEmail = (email) => {
        return /^[^@]+@[^@]+\.[^@]+$/.test(email); 
    };

    const sendEmail = (e) => {
        e.preventDefault();
        
        if (!validateEmail(email)) {
            setError('❌ Invalid email format! Please enter a correct email.');
            setSuccessMessage('');
            return;
        }
        
        setError(''); // Clear error if valid
        emailjs
          .sendForm('service_mxsid2q', 'template_p4tp3eo', form.current, {
            publicKey: 'T2Ba5ySMtBJOYJmpj',
          })
          .then(
            () => {
              setSuccessMessage('✅ Your email has been sent successfully!');
              form.current.reset();
              setEmail('');
            },
            (error) => {
              console.log('FAILED...', error.text);
            },
          );
      };

  return (
    <div className="Join" id="Join-us">
        <div className="left-j">
            <hr/>
            <div>
                <span className='stroke-text'>READY TO</span>
                <span>LEVEL UP</span>
            </div>
            <div>
                <span>YOUR BODY</span>
                <span className='stroke-text'>WITH US?</span>
            </div>
        </div>

        <div className="right-j">
            <form ref={form} className="email-container" onSubmit={sendEmail}>
                <input 
                    type="email" 
                    name='user_email' 
                    placeholder='Enter your email address' 
                    value={email} 
                    onChange={(e) => setEmail(e.target.value)}
                />
                <button className='btn btn-j'>Join Now</button>
            </form>
            {error && <div className='error-message'>{error}</div>}
            {successMessage && <div className='success-message'>{successMessage}</div>}
        </div>
    </div>
  );
}

export default Join;
